module.exports = __webpack_public_path__ + "media/search/residential_grayscale-bd8311e0.png";